import styled from "styled-components";
import { colors, easing, fonts, media, radii, shadows } from "../../../theme";

export const CardIcon = styled.span`
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  border-radius: 0.9rem;
  background-color: ${colors.primary};
  color: ${colors.secondary};
  font-size: 1.3rem;
  transition: transform 0.6s ${easing.out}, background-color 0.3s ease;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  height: 100%;
  padding: 1.75rem;
  border: 1px solid rgba(210, 180, 140, 0.45);
  border-radius: ${radii.lg};
  background-color: ${colors.backgroundSecondary};
  transition: transform 0.5s ${easing.out}, box-shadow 0.5s ${easing.out},
    border-color 0.3s ease;

  ${media.hoverable} {
    &:hover {
      transform: translateY(-6px);
      border-color: ${colors.primary};
      box-shadow: ${shadows.lg};
    }

    &:hover ${CardIcon} {
      transform: rotate(-8deg) scale(1.08);
      background-color: ${colors.buttonHover};
    }
  }
`;

export const CardLabel = styled.h2`
  margin-top: 0.4rem;
  font-family: ${fonts.body};
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${colors.textMuted};
`;

export const CardItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const CardLink = styled.a`
  font-weight: 600;
  line-height: 1.45;
  color: ${colors.textMain};
  text-decoration: none;
  overflow-wrap: anywhere;
  background-image: linear-gradient(${colors.primary}, ${colors.primary});
  background-size: 0% 2px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  transition: background-size 0.4s ${easing.out}, color 0.3s ease;

  &:hover {
    color: ${colors.textSecondary};
    background-size: 100% 2px;
  }
`;
